
import { Component, AfterViewInit, OnDestroy, Input } from '@angular/core';
import 'owl.carousel';
declare var $: any; // Esto es necesario para evitar problemas con TypeScript

@Component({
  selector: 'app-clients',
  templateUrl: './clients.html',
  styleUrls: ['./clients.scss']
})
export class ClientsComponent implements AfterViewInit, OnDestroy {
  private owlInstance: any;
  @Input() pb!: string;
  @Input() pt!: string;

  ngAfterViewInit(): void {
    this.initOwlCarousel();
  }

  initOwlCarousel() {
    setTimeout(() => {
      this.owlInstance = $('.brand-wrap').owlCarousel({
        loop: true,
        nav: false,
        autoplay: true,
        autoplayHoverPause: true,
        mouseDrag: true,
        margin: 0,
        center: false,
        dots: false,
        slideTransition: 'linear',
        autoplayTimeout: 4500,
        autoplaySpeed: 4500,
        responsive: {
          0: {
            items: 2
          },
          576: {
            items: 3
          },
          768: {
            items: 4
          },
          992: {
            items: 5
          },
          1200: {
            items: 5
          }
        }
      });
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.owlInstance) {
      this.owlInstance.trigger('destroy.owl.carousel');
    }
  }
}
